module.exports = __webpack_public_path__ + "assets/apple-touch-icon-120-devel-21f757.png";